<template>
  <div></div>
</template>
<script>
import { getParamFromUrl } from '@/utils/common.js'
import { baseUrlMap } from '@/fetch'
export default {
  created() {
    this.checkTicketId()
  },
  methods: {
    checkTicketId() {
      const ticketId = getParamFromUrl('ticketId')
      const redirectUrl = getParamFromUrl('redirectUrl')
      // https://mapi.zjzwfw.gov.cn/web/mgop/gov-open/zj/2001999672/lastTest/index.html?appId=2001815934&env=test
      // https://mapi.zjzwfw.gov.cn/web/mgop/gov-open/zj/2001999672/lastTest/index.html#/authentication?redirectUrl=https%3A%2F%2Fmapi.zjzwfw.gov.cn%2Fweb%2Fmgop%2Fgov-open%2Fzj%2F2001999672%2FlastTest%2Findex.html%3FappId%3D2001815934%26env%3Dtest&ticketId=6ce73607f32341ac8a66319ce87b24f8

      // https://mapi.zjzwfw.gov.cn/web/mgop/gov-open/zj/2001999672/lastTest/index.html?appId=2001815934&token=bc61392bfc4c4aba8614a71ce0c2e43d&gxdjpersonkey=bc61392bfc4c4aba8614a71ce0c2e43d&gxdjcode=0067b27d8c384cccad5ca6b71f8db05f
      // http://localhost:7001/?appId=2001815934&token=bc61392bfc4c4aba8614a71ce0c2e43d&gxdjpersonkey=bc61392bfc4c4aba8614a71ce0c2e43d&gxdjcode=0067b27d8c384cccad5ca6b71f8db05f
      if (ticketId && redirectUrl) {
        const env = getParamFromUrl('env', decodeURIComponent(redirectUrl))
        const appId = getParamFromUrl('appId', decodeURIComponent(redirectUrl))
        const mapKey = env === 'test' ? 'testMicroApp' : 'prodMicroApp'
        const callbackUrl = `${baseUrlMap[mapKey]}/api/sso/zlbsso/getTokenByTicketId`
        // encodeURIComponent
        window.location.href = `${callbackUrl}?ticketId=${ticketId}&appId=${appId}&redirectUrl=${encodeURIComponent(redirectUrl)}`
      }
    }
  }
}
</script>
